import Icon from "components/AppIcon";
import Header from "components/ui/Header";
import Input from "components/ui/Input";
import Sidebar from "components/ui/Sidebar";
import { useEffect, useState } from "react";
import QrFilterToolbar from "./components/qrFilterToolbar";
import QrTable from "./components/qrdatatable";
import ScanlogModal from "./components/ScanlogModal";

export default function QRCodeManagement() {
    const token = localStorage.getItem('token');
    const [loading, setloading] = useState(true);
    const [sidebarCollapsed, setSidebarCollapsed] = useState(true);
    const [buttonLoading, setButtonLoading] = useState(false)
    const [permissions, setPermissions] = useState([]);
    const [qrData, setQrData] = useState([]);
    const [totalQr, setTotalQr] = useState(0);
    const [totalScan, setTotalScans] = useState(0);
    const [filteredQrData, setFilteredQrData] = useState([]);
    const [companyNames, setCompanyNames] = useState([]);
    const [selectedCompany, setSelectedCompany] = useState("All");
    const [searchTerm, setSearchTerm] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [alldata, setAllData] = useState([])
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [limit] = useState(10);

    const [currentUser] = useState(() => {
        try {
            return JSON.parse(localStorage.getItem('user'));
        } catch (error) {
            return null;
        }
    })

    const onClose = () => { setShowModal(false) }
    const toggleSidebar = () => {
        setSidebarCollapsed(!sidebarCollapsed);
    };

    useEffect(() => {
        if (currentUser) fetchPermission(currentUser);
    }, [currentUser?.email]);

    useEffect(() => {
        const fetchQrCodes = async () => {
            setloading(true);
            const res = await fetch(import.meta.env.VITE_APP_ADMINURL + `/api/getallqrcode?page=${page}&limit=${limit}&search=${encodeURIComponent(searchTerm)}&company=${encodeURIComponent(selectedCompany)}`, {
                method: "GET",
                headers: {
                    'content-type': 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            })
            const result = await res.json();
            const data = result.data
            setQrData(data)
            setFilteredQrData(data)
            setTotalQr(result.pagination.totalQr);
            setTotalScans(result.pagination.totalScans);
            setTotalPages(result.pagination.totalPages);
            setCompanyNames(result.companies);
            if (page > result.pagination.totalPages) {
                setPage(1)
            }
            setloading(false);
        };

        fetchQrCodes();
    }, [page, searchTerm, selectedCompany])

    const fetchPermission = async () => {
        const response = await fetch(import.meta.env.VITE_APP_ADMINURL + `/api/permission`, {
            method: "GET",
            headers: {
                'content-type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        }
        )
        const availablePermissions = await response.json()
        setPermissions(availablePermissions)
        return availablePermissions
    }

    const handleCompanyFilter = (company) => {
        setSelectedCompany(company);
    };

    const handleSearch = (term) => {
        setSearchTerm(term);
    }

    const handlerowClick = async (id) => {
        // console.log("i am clicked",id)
        const response = await fetch(import.meta.env.VITE_APP_ADMINURL + `/api/getScanlogByQrUniqueNo/${id}`, {
            method: 'GET',
            headers: {
                'content-type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        })

        const data = await response.json();
        setAllData(data);
        setShowModal(true);
    }

    const handleDownload = async () => {
        setButtonLoading(true)
        try {
            const url = `${import.meta.env.VITE_APP_ADMINURL}/api/exportQrdata?search=${encodeURIComponent(searchTerm)}&company=${encodeURIComponent(selectedCompany)}`;

            const res = await fetch(url, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (!res.ok) {
                console.error("Export failed");
                return;
            }

            const blob = await res.blob();
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = "qrcode_export.xlsx";
            link.click();
            window.URL.revokeObjectURL(link.href);
        } catch (error) {
            console.error(error)
        } finally {
            setButtonLoading(false)
        }
    };


    return (
        <div className="min-h-screen bg-background">
            <Header
                user={currentUser}
                onMenuToggle={toggleSidebar}
                sidebarCollapsed={sidebarCollapsed}
            />
            <Sidebar
                onToggle={toggleSidebar}
                collapsed={sidebarCollapsed}
                permissions={permissions}
            />
            <main className={`pt-header-height nav-transition ${sidebarCollapsed ? 'lg:pl-sidebar-collapsed' : "lg:pl-sidebar-width"}`}>
                <div className="p-6">
                    <div className="mb-6">
                        <h1 className="text-3xl font-heading font-bold text-text-primary mb-2">Qr Code Dashboard</h1>
                        <p className="text-text-secondary">View and manage your Qrcode scanlogs</p>
                    </div>
                    <div className="flex gap-2 ">
                        <div className="flex-1 flex justify-between bg-surface border border-border rounded-lg p-6">
                            <div>
                                <h2 className=" font-heading font-bold text-text-primary text-lg ">
                                    Total Qr Codes
                                </h2>
                                <div>
                                    {totalQr}
                                </div>
                            </div>
                            <div>
                                <Icon name="QrCode" size={50} />
                            </div>
                        </div>
                        <div className="flex-1 flex justify-between bg-surface border border-border rounded-lg p-6">
                            <div>
                                <h2 className="font-heading font-bold text-text-primary text-lg">
                                    Total Scans
                                </h2>
                                <div>
                                    {totalScan}
                                </div>
                            </div>
                            <div>
                                <Icon name="ScanFace" size={50} />
                            </div>
                        </div>
                    </div>
                    {/* search & filter */}
                    <QrFilterToolbar
                        companyNames={['All', ...companyNames]}
                        selectedCompany={selectedCompany}
                        onCompanyChange={handleCompanyFilter}
                        searchTerm={searchTerm}
                        onSearch={handleSearch}
                        buttonLoading={buttonLoading}
                        handleDownload={handleDownload}
                    />
                    <QrTable datas={filteredQrData} handlerowClick={handlerowClick} loading={loading} />
                    <div className="flex justify-center gap-4 items-center my-4">
                        <button
                            className="px-3 py-1 border rounded disabled:opacity-50"
                            onClick={() => setPage((p) => Math.max(p - 1, 1))}
                            disabled={page === 1}
                        >
                            Previous
                        </button>

                        <span className="text-sm">
                            Page {page} of {totalPages}
                        </span>

                        <button
                            className="px-3 py-1 border rounded disabled:opacity-50"
                            onClick={() => setPage((p) => Math.min(p + 1, totalPages))}
                            disabled={page === totalPages}
                        >
                            Next
                        </button>
                    </div>

                    {showModal && <ScanlogModal onClose={onClose} alldata={alldata} />}
                </div>
            </main>
        </div>
    )
}
